import axios from "../../utils/axios";

export const getJobs = async()=>{
   
    const response = await axios.get('/jobs');
   

    return response

}
export const getJob = async(id)=>{
    const response = await axios.get(`/jobs/${id}`);
    return response

}

export const postJob = async(data)=>{
    const response = await axios.post('/jobs',data);
    return response

}
export const updateJob = async(data)=>{

   const {id, ...dataAll} = data
    const response = await axios.patch(`/jobs/${id}`,dataAll);
    return response

}
export const deleteJob = async(id)=>{
    

    const response = await axios.delete(`/jobs/${id}`);
    return response

}